(function() {
  if (window.printerCompatibilityInitialized) return;
  window.printerCompatibilityInitialized = true;
  
  // Event Delegation - funktioniert für alle Elemente, auch nachträglich geladene
  document.addEventListener('click', function(e) {
    const row = e.target.closest('.spec-row-compatibility');
    if (!row) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const productId = row.dataset.productId;
    const productBrand = row.dataset.productBrand;
    const printerTags = JSON.parse(row.dataset.printerTags);
    
    let tooltip = document.querySelector('.printer-compatibility-tooltip[data-product="' + productId + '"]');
    
    if (tooltip && tooltip.classList.contains('show')) {
      closeTooltip(tooltip);
      return;
    }
    
    document.querySelectorAll('.printer-compatibility-tooltip').forEach(t => closeTooltip(t));
    
    if (!tooltip) {
      tooltip = createTooltip(printerTags, productId, productBrand);
      document.body.appendChild(tooltip);
    }
    
    const isMobile = window.innerWidth < 750;
    if (!isMobile) {
      const rect = row.getBoundingClientRect();
      tooltip.style.top = (rect.bottom + window.scrollY + 10) + 'px';
      tooltip.style.left = (rect.left + window.scrollX) + 'px';
    }
    
    let backdrop = document.querySelector('.tooltip-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'tooltip-backdrop';
      backdrop.addEventListener('click', (e) => {
        e.stopPropagation();
        const activeTooltip = document.querySelector('.printer-compatibility-tooltip.show');
        if (activeTooltip) closeTooltip(activeTooltip);
      });
      document.body.appendChild(backdrop);
    }
    
    if (isMobile) {
      backdrop.classList.add('show');
    }
    
    setTimeout(() => tooltip.classList.add('show'), 10);
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const activeTooltip = document.querySelector('.printer-compatibility-tooltip.show');
      if (activeTooltip) closeTooltip(activeTooltip);
    }
  });
  
  function createTooltip(tags, productId, brandName) {
    const tooltip = document.createElement('div');
    tooltip.className = 'printer-compatibility-tooltip';
    tooltip.dataset.product = productId;
    
    tooltip.innerHTML = `
      <div class="tooltip-header">
        <h4>Kompatible ${brandName} Drucker (${tags.length})</h4>
        <button class="tooltip-close" aria-label="Schließen">&times;</button>
      </div>
      <div class="tooltip-search">
        <input type="text" placeholder="Drucker suchen..." class="tooltip-search-input">
      </div>
      <div class="tooltip-list">
        <ul>
          ${tags.map(tag => `<li data-printer="${tag.toLowerCase()}">${tag}</li>`).join('')}
        </ul>
        <div class="tooltip-list-empty">Kein passendes Modell gefunden.</div>
      </div>
    `;
    
    tooltip.querySelector('.tooltip-close').addEventListener('click', (e) => {
      e.stopPropagation();
      closeTooltip(tooltip);
    });
    
    const searchInput = tooltip.querySelector('.tooltip-search-input');
    const listItems = tooltip.querySelectorAll('.tooltip-list li');
    const emptyMessage = tooltip.querySelector('.tooltip-list-empty');
    
    searchInput.addEventListener('input', function() {
      const query = this.value.toLowerCase().trim();
      let visibleCount = 0;
      
      listItems.forEach(item => {
        const printerName = item.dataset.printer;
        if (printerName.includes(query)) {
          item.classList.remove('hidden');
          visibleCount++;
        } else {
          item.classList.add('hidden');
        }
      });
      
      emptyMessage.style.display = visibleCount === 0 ? 'block' : 'none';
    });
    
    tooltip.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    
    return tooltip;
  }
  
  function closeTooltip(tooltip) {
    tooltip.classList.remove('show');
    const backdrop = document.querySelector('.tooltip-backdrop');
    if (backdrop) backdrop.classList.remove('show');
    setTimeout(() => {
      if (tooltip.parentNode) tooltip.remove();
      if (backdrop && backdrop.parentNode) backdrop.remove();
    }, 200);
  }
})();
